<template>
  <v-dialog v-model="showModal" persistent max-width="600" scrollable>
    <v-card>
      <v-layout>
        <v-flex>
          <div class="text-xs-right">
            <v-btn flat fab small :disabled="isLoading" @click="$emit('close')">
              <v-icon
                style="display: flex; align-items: center; justify-content: center; padding: 0"
                >close</v-icon
              >
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <template v-if="isLoading">
        <div
          class="py-5"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          "
        >
          <scale-loader
            :loading="isLoading"
            :color="$vuetify.theme.primary"
            height="45px"
            width="7px"
          />
          <h3 class="headline">{{ $t('Uploading') }}...</h3>
        </div>
      </template>
      <template v-else>
        <v-card-text style="padding-bottom: 120px">
          <v-layout wrap row>
            <v-flex xs12 class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
              <label>{{ $t('Topic Name') }}</label>
              <input
                v-model="name"
                v-validate="'required'"
                :data-vv-as="$t('Topic Name')"
                name="name"
                class="form-control"
                type="text"
                required
                :placeholder="$t('Topic Name')"
              />
              <span v-if="errors.has('name')" class="text-error">{{ errors.first('name') }}</span>
            </v-flex>

            <v-flex xs12 class="form-control pa-1" :class="{ 'has-error': errors.has('type') }">
              <label for="type">{{ $t('Select Type') }}</label>
              <multiselect
                v-model="upload_type"
                v-validate="'required'"
                :options="options"
                label="label"
                select-label
                selected-label
                deselect-label
                track-by="value"
                :multiple="false"
                :placeholder="$t('Select Type')"
                name="type"
                :data-vv-as="$t('Select Type')"
              >
              </multiselect>
              <span v-if="errors.has('type')" class="text-error">{{ errors.first('type') }}</span>
            </v-flex>

            <template v-if="['text'].includes(upload_type.value)">
              <v-flex
                xs12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('message') }"
              >
                <label>{{ $t('Message') }}</label>
                <AutoResizeTextarea
                  v-model="message"
                  v-validate="{ required: ['text'].includes(upload_type.value) }"
                  :data-vv-as="$t('Message')"
                  name="message"
                  required
                  :placeholder="$t('Message')"
                />
                <span v-if="errors.has('message')" class="text-error">{{
                  errors.first('message')
                }}</span>
              </v-flex>
            </template>

            <template v-if="['file'].includes(upload_type.value)">
              <v-flex v-if="file == null" xs12 class="pa-1">
                <GptConversationUpload @change="handleUploadFile" />
                <span v-if="showFileError" class="text-error">{{
                  $t('Required', { field: $t('File') })
                }}</span>
              </v-flex>
              <v-flex v-else xs12 class="pa-1">
                <label>{{ $t('File') }}</label>
                <v-card style="border-radius: 4px">
                  <v-layout class="px-3">
                    <v-flex xs10 style="display: flex; align-items: center">
                      <span style="margin: 0">
                        {{ file.name }}
                      </span>
                    </v-flex>
                    <v-flex xs2>
                      <div class="text-xs-right">
                        <v-btn fab flat small color="primary" @click="file = null">
                          <v-icon
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              padding: 0;
                            "
                            >delete</v-icon
                          >
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </template>
            <template v-if="['website'].includes(upload_type.value)">
              <v-flex
                xs12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('website') }"
              >
                <label>{{ $t('Link') }}</label>
                <input
                  v-for="(item, index) in url"
                  :key="`link_${index}`"
                  v-model="item.link"
                  v-validate="{ required: ['website'].includes(upload_type.value) }"
                  :data-vv-as="$t('Link')"
                  name="website"
                  class="form-control"
                  type="text"
                  :placeholder="$t('Link')"
                  required
                />
                <span v-if="errors.has('website')" class="text-error">{{
                  errors.first('website')
                }}</span>
              </v-flex>
              <!-- <v-flex xs12 style="display: flex; justify-content: flex-end">
                <v-btn depressed color="primary" style="margin: 0" @click="handleAddLink">{{
                  $t('Add')
                }}</v-btn>
              </v-flex> -->
            </template>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="handleSubmitForm">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import AutoResizeTextarea from '@/components/elements/AutoresizeTextarea'
import GptConversationUpload from './GptConversationUpload.vue'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import gptApi from '@/api/gpt'
export default {
  components: { Multiselect, AutoResizeTextarea, GptConversationUpload, ScaleLoader },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      upload_type: '',
      options: [
        { label: this.$t('Text Message'), value: 'text' },
        { label: this.$t('Upload File'), value: 'file' },
        { label: this.$t('Website'), value: 'website' }
      ],
      message: '',
      file: null,
      url: [{ link: '' }],
      showFileError: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    showModal(isShow) {
      if (!isShow) this.handleResetForm()
    }
  },
  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    })
  },
  methods: {
    handleAddLink() {
      this.url.push({ link: '' })
    },
    handleUploadFile(file) {
      if (!file) return
      this.file = file
      this.showFileError = false
    },
    handleResetForm() {
      this.name = ''
      this.upload_type = ''
      this.file = null
      this.message = ''
      this.url = [{ link: '' }]
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    async handleSubmitForm() {
      try {
        const result = await this.$validator.validateAll()
        if (!result) {
          return false
        }
        if (['text'].includes(this.upload_type.value)) {
          const payload = {
            name: this.name,
            upload_type: this.upload_type.value,
            text: this.message,
            file_url: null,
            urls: null
          }
          this.handleSendDataPayload(payload)
        }
        if (['file'].includes(this.upload_type.value)) {
          if (this.file === null) {
            this.showFileError = true
            return
          }
          this.handleUploadFileToS3(this.file)
        }
        if (['website'].includes(this.upload_type.value)) {
          const payload = {
            name: this.name,
            upload_type: this.upload_type.value,
            text: null,
            file_url: null,
            urls: this.url.map((item) => item.link.trim())
          }
          this.handleSendDataPayload(payload)
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadFileToS3(file) {
      if (!file) return
      let vm = this
      vm.isLoading = true
      const fileName = file.name.split('.')
      let data = {
        name: `document_${Date.now()}.${fileName[fileName.length - 1]}`,
        type: file.type,
        file: file
      }
      api.getSignedRequest(data, function (error, url) {
        if (error) {
          console.error(error)
          return
        }
        url = encodeURI(url)
        const payload = {
          name: vm.name,
          upload_type: 'file',
          text: null,
          file_url: url,
          urls: null
        }
        vm.handleSendDataPayload(payload)
      })
    },
    async handleSendDataPayload(payload) {
      try {
        if (Object.keys(payload).length <= 0) return
        this.isLoading = true
        const response = await gptApi.postUploadDocument({
          pageId: this.selectedBot.pageid,
          data: payload
        })
        const { data } = response
        if ([200].includes(data.status_code)) {
          this.$emit('close')
          this.$swal
            .fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })
            .then(() => {
              this.$emit('refresh')
            })
        } else {
          this.$swal.fire({
            title: this.$t('Error'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          title: this.$t('Error'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="css" scoped>
textarea {
  padding: 12px 20px !important;
  font-size: 16px !important;
}
.text-error {
  color: red;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/gpt/GptConversationCreateDialog.vue